export const caseConstants = {
  touchBreakpoint: 999,

  defaultUserEmail: 'admin@buddyweb.fr',
  defaultUserPassword: 'buddyweb'
}
